import React from 'react'

export default props => (
    <section className='content' style={{ padding: 8 }}>
		{props.children}
	</section>
)
